import React, { useEffect, useState } from "react";
import { styled } from "@mui/styles";
import {
    Box, Stack, Button, Grid, useTheme, Container,
    useMediaQuery
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import "../../styles/admin.css";
import { Link as ScrollLink } from 'react-scroll';

import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

//import { useRecoilState } from "recoil";
//import { profileState } from "../recoil/profile-atom";
//import { getApiCallDynamic } from "../services/api-service";
//import { API } from "../services/api-config";
//import ConfirmationModel from "../helpers/modal/confirm-modal";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HelpIcon from '@mui/icons-material/Help';
//import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
//import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate } from "react-router-dom";
//import { Path } from "../routes/route-config";
import Logo from "../../assets/logo.png";

//import { KSArrowLeftIcon } from "../icons/custome-icon";
import { Link } from 'react-router-dom';
import { signInUrl, supportUsersGuideUrl } from "../../config/siteUrls";

const useStyle = makeStyles({
    iconColor: {
        color: "white",
    },
});

//white space for main content area
const drawerWidth = 310;

//menu bar onclick drawer open
const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    }),
}));

export default function KSLoanAppbar({ appbarBackNavigation, ...props }) {
    //const router = useNavigate();
    const classes = useStyle();
    const location = useLocation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    // app bar user account state
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open_user = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElProduct, setAnchorElProduct] = useState(null);
    const [anchorElAbout, setAnchorElAbout] = useState(null);


    // drawer state
    const { open, handleDrawerOpen, toptitle } = props;

    const handleSignin = () => {
        window.location.href = signInUrl;
    };

    const handleUserGuide = () => {
        window.open(supportUsersGuideUrl, "_blank", "noopener,noreferrer");
    };

    const handleLogout = () => {
        localStorage.setItem('cliqloan-user-user-session', 'signout');
        window.location.replace(signInUrl);
    };
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <>
            {/* appbar area start here */}
            <Container maxWidth="xl" bgcolor={'#ffffff'}>
                <AppBar position="fixed" open={open} sx={{ backgroundColor: '#FFFFFF', boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}>
                    <Toolbar sx={{ px: "8px !important" }}>

                        <Box
                            display={"flex"}
                            justifyContent={"space-between"}
                            width={"100%"}
                            overflow={"hidden"}

                        >
                            <Stack
                                direction={"row"}
                                alignItems={"center"}
                                gap={{ sm: 0, md: 1 }}
                            >
                                {/* <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                sx={{
                  ...(open && { display: "none" }),
                }}
              >
                <MenuIcon />
              </IconButton> */}

                                <Box ml={isSmallScreen ? 0 : 12}>
                                    <a href="/support" style={{ textDecoration: "none" }}>
                                        <img src={Logo} className="imglogo" alt="Logo" height={21} width={110} style={{ alignItems: 'left' }} />
                                    </a>
                                </Box>
                                {
                                    appbarBackNavigation && <IconButton color="inherit" onClick={() => {
                                        //  router(location.pathname.split("/").at(-3));
                                    }}>
                                        {/* <KSArrowLeftIcon /> */}
                                    </IconButton>
                                }

                                <Typography
                                    variant={{ sm: "body1", md: "h6" }}
                                    fontWeight={{ sm: "normal", md: "bold" }}
                                >
                                    {toptitle}
                                </Typography>
                            </Stack>

                            <Stack
                                direction={"row"}
                                alignItems={"right"}
                                gap={{ sm: 0, md: 1 }}
                            >
                                <Box display="flex" alignItems="center" justifyContent="flex-end">
                                    <Grid mr={0}>

                                        <Box display="flex" alignItems="center" justifyContent="flex-end" sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
                                            <Stack direction={"row"} spacing={2} ml={1}>




                                                {/* <Button
                                                    variant="outlined"
                                                    sx={{
                                                        ml: 2,
                                                        textTransform: "none",
                                                        bgcolor: "transparent",
                                                        color: "#31B9B5",
                                                        transition: "background-color 0.3s",

                                                        "&:hover": {
                                                            bgcolor: "#E0E0E0",
                                                        },
                                                        width: 'auto', // Adjust width to fit content
                                                        height: '32px',
                                                        padding: '5px 14px', // Adjust padding as necessary
                                                        border: '1px solid #31B9B5',
                                                        borderRadius: '57px', // Adjust border radius as needed, // Adjust padding as necessary


                                                    }}
                                                    onClick={handleDashboard}
                                                >
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            fontFamily: 'Inter',
                                                            fontWeight: 500,
                                                            fontSize: '14px',
                                                            lineHeight: '16px'
                                                        }}
                                                    >
                                                        Schedule a demo
                                                    </Typography>
                                                </Button> */}
                                                <Stack direction={"row"} spacing={2} ml={1}>

                                                    <Button
                                                        variant="contained"

                                                        onClick={() => window.location.href = signInUrl}
                                                    >
                                                        Sign in
                                                    </Button>
                                                </Stack>

                                                {/* <Button
                                                    variant="contained"




                                                    // sx={{
                                                    //     ml: 2,
                                                    //     textTransform: "none",
                                                    //     bgcolor: "primary",
                                                    //     color: "secondary",
                                                    //     transition: "background-color 0.3s",
                                                    //     "&:hover": {
                                                    //         bgcolor: "#E0E0E0",
                                                    //     },
                                                    //     width: 'Hug(86px)',
                                                    //     height: 'Fixed(32px)',


                                                    // }}
                                               
                                                    onClick={() => window.location.href = signInUrl}
                                                >
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            fontFamily: 'Inter',
                                                            fontWeight: 500,
                                                            fontSize: '14px',
                                                            lineHeight: '16px'
                                                        }}
                                                    >
                                                        Sign in
                                                    </Typography>

                                                </Button> */}
                                            </Stack>
                                        </Box>

                                    </Grid>
                                </Box>
                                <Tooltip >
                                    <IconButton
                                        onClick={() => {

                                        }}
                                    >
                                        <HelpIcon className={classes.iconColor} />
                                    </IconButton>

                                </Tooltip>

                                <Tooltip >
                                    <IconButton
                                        id="notificaiton-button"

                                        aria-haspopup="true"

                                    >

                                    </IconButton>
                                </Tooltip>
                                <Menu
                                    id="notificaiton-menu"
                                    // anchorEl={notificationEl}
                                    // open={notificaitonOpen}
                                    // onClose={notificationClose}
                                    MenuListProps={{
                                        "aria-labelledby": "notificaiton-button",
                                    }}
                                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                                >

                                </Menu>

                                <Tooltip >
                                    <IconButton
                                        //onClick={handleClick}
                                        size="medium"
                                        aria-controls={open_user ? "account-menu" : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open_user ? "true" : undefined}
                                    >
                                        {/* <AccountCircleOutlinedIcon className={classes.iconColor} /> */}
                                    </IconButton>
                                </Tooltip>
                                <Menu
                                    anchorEl={anchorEl}
                                    id="account-menu"
                                    open={open_user}
                                    onClose={handleMenuClose}
                                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                                >
                                    <MenuItem>
                                        <ListItemIcon>
                                            <VerifiedUserIcon fontSize="small" />
                                        </ListItemIcon>
                                        {/* {profileData?.firstName} */}
                                    </MenuItem>
                                    <MenuItem>
                                        <ListItemIcon>
                                            <RecentActorsIcon fontSize="small" />
                                        </ListItemIcon>
                                        {/* {profileData?.role} */}
                                    </MenuItem>
                                    <Divider />
                                    {/* <ConfirmationModel
                  body={
                    <MenuItem>
                      <ListItemIcon>
                        <Logout fontSize="small" />
                      </ListItemIcon>
                      Logout
                    </MenuItem>
                  }
                  handleSubmit={props.handleLogout}
                  message="Are you sure, You want to Logout?"
                  title={"Confirmation"}
                /> */}
                                </Menu>


                                <Box
                                    justifyContent="flex-end"
                                    sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
                                >
                                    <IconButton
                                        size="large"
                                        edge="start"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="inherit"
                                        style={{ color: "grey" }} // Add this style prop
                                    >
                                        <MenuIcon className={classes.menuIcon} />
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "left",
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: "top",
                                            horizontal: "left",
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={handleCloseNavMenu}
                                        sx={{
                                            display: { xs: "block", md: "none" },
                                        }}
                                    >
                                        <ScrollLink
                                            to="product"
                                            smooth={true}
                                            duration={500}
                                            onClick={handleSignin}
                                        >
                                            <MenuItem >
                                                <Typography textAlign="center">Sign in</Typography>
                                            </MenuItem>
                                        </ScrollLink>

                                        {/*   <ScrollLink
                                            to="aboutus"
                                            smooth={true}
                                            duration={500}
                                            onClick={handleLogout}
                                        >
                                            <MenuItem sx={{ fontSize: "12px", fontFamily: "Inter", fontWeight: 500 }}>
                                                <Typography textAlign="center">Logout</Typography>
                                            </MenuItem>
                                        </ScrollLink> */}

                                    </Menu>
                                </Box>
                            </Stack>
                        </Box>
                    </Toolbar>
                </AppBar>
            </Container >
            {/* AppBar area end here */}
        </>
    );
}
